import { Badge } from "@shared/ui/badge";
import { AlertTriangle, Check, Info } from "lucide-react";
import React from "react";

interface ReadingStatusBadgeProps {
  status: "Normal" | "Faulty" | "RCNT";
  size?: "sm" | "md";
}

const ReadingStatusBadge: React.FC<ReadingStatusBadgeProps> = ({
  status,
  size = "sm",
}) => {
  let color, icon, label;
  switch (status) {
    case "Normal":
      color = "bg-green-50 text-green-700 border-green-300";
      icon = <Check className="w-3 h-3 mr-1" />;
      label = "Normal";
      break;
    case "Faulty":
      color = "bg-red-50 text-red-700 border-red-300";
      icon = <AlertTriangle className="w-3 h-3 mr-1" />;
      label = "Faulty";
      break;
    case "RCNT":
      color = "bg-yellow-50 text-yellow-700 border-yellow-300";
      icon = <Info className="w-3 h-3 mr-1" />;
      label = "RCNT";
      break;
    default:
      color = "bg-muted/50 text-muted-foreground border-muted-200";
      icon = null;
      label = status;
  }
  return (
    <Badge
      className={`inline-flex items-center border ${color} px-2 py-0.5 text-xs font-semibold ${
        size === "sm" ? "h-5" : "h-6"
      }`}
      variant="outline"
    >
      {icon}
      {label}
    </Badge>
  );
};

export default ReadingStatusBadge;
